$(document).ready(function () {

    $('.config .column ul.clickable li').click(function () {

        $('.config .column ul.clickable li').removeClass('active');
        $(this).addClass('active');
        $(this).parent('ul').parent('.column').parent('.row').fadeOut();
        var question = $(this).parent('ul').parent('.column').parent('.row').attr('data-question');
        var next = parseInt(question) + 1;
        setTimeout(function () {
            $('.config #question' + next).slideDown();
        }, 600);
    });

    $('.config .column ul.collectable li').click(function () {

        $(this).addClass('active');
        var question = $(this).parent('ul').parent('.column').parent('.row').attr('data-question');
        setTimeout(function () {
            $('.config #popup').show();
        }, 600);
    });

    $('.config .btn').click(function (e) {
        e.preventDefault();
        setTimeout(function () {
            $('.config #popup').addClass('active');
        }, );
    });

    $('.config .column ul li#form_a').click(function () {

        $('#popup form').hide();
        $('#popup form.form_a').show();

    });

    $('.config .column ul li#form_b').click(function () {

        $('#popup form').hide();
        $('#popup form.form_b').show();

    });

    $('.config .column ul li#form_c').click(function () {

        $('#popup form').hide();
        $('#popup form.form_c').show();

    });

    $('.config .column ul li#form_d').click(function () {

        $('#popup form').hide();
        $('#popup form.form_d').show();

    });

    $('.config .column ul li#form_e').click(function () {

        $('#popup form').hide();
        $('#popup form.form_e').show();

    });

    $('.config .column ul li#form_f').click(function () {

        $('#popup form').hide();
        $('#popup form.form_f').show();

    });

    $('.config .column ul li#recommend_a').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_a').show();

    });

    $('.config .column ul li#recommend_b').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_b').show();

    });

    $('.config .column ul li#recommend_c').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_c').show();

    });

    $('.config .column ul li#recommend_d').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_d').show();

    });

    $('.config .column ul li#recommend_e').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_e').show();

    });

    $('.config .column ul li#recommend_f').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_f').show();

    });

    $('.config .column ul li#recommend_g').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_g').show();

    });

    $('.config .column ul li#recommend_h').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_h').show();

    });

    $('.config .column ul li#recommend_i').click(function () {

        $('.config .column ul li.recommended_products').hide();
        $('.config .column ul li.recommended_products.recommend_i').show();

    });
      
    $('.config .column ul li.recommended_products').click(function (e) {

        $(this).find('.config_preview').toggleClass('active');

    });
      
    $('#popup-close').click(function (e) {

        $('#popup').removeClass('active');

    });

});